__turbopack_context__.v({
  "cartBadge": "Header-module__gGWhea__cartBadge",
  "cartCount": "Header-module__gGWhea__cartCount",
  "headerSearchBar": "Header-module__gGWhea__headerSearchBar",
  "headerSearchBtn": "Header-module__gGWhea__headerSearchBtn",
  "headerSearchFocused": "Header-module__gGWhea__headerSearchFocused",
  "headerSearchForm": "Header-module__gGWhea__headerSearchForm",
  "headerSearchIcon": "Header-module__gGWhea__headerSearchIcon",
  "headerSearchIconBtn": "Header-module__gGWhea__headerSearchIconBtn",
  "headerSearchInner": "Header-module__gGWhea__headerSearchInner",
  "headerSearchInput": "Header-module__gGWhea__headerSearchInput",
  "homeBtn": "Header-module__gGWhea__homeBtn",
  "homeCircle": "Header-module__gGWhea__homeCircle",
  "iconBtn": "Header-module__gGWhea__iconBtn",
  "iconGroup": "Header-module__gGWhea__iconGroup",
  "mobileBottomNav": "Header-module__gGWhea__mobileBottomNav",
  "navButton": "Header-module__gGWhea__navButton",
  "navGroup": "Header-module__gGWhea__navGroup",
  "searchBarContent": "Header-module__gGWhea__searchBarContent",
  "searchNoResult": "Header-module__gGWhea__searchNoResult",
  "searchOrb1": "Header-module__gGWhea__searchOrb1",
  "searchOrb2": "Header-module__gGWhea__searchOrb2",
  "searchSuggestionCode": "Header-module__gGWhea__searchSuggestionCode",
  "searchSuggestionImage": "Header-module__gGWhea__searchSuggestionImage",
  "searchSuggestionInfo": "Header-module__gGWhea__searchSuggestionInfo",
  "searchSuggestionItem": "Header-module__gGWhea__searchSuggestionItem",
  "searchSuggestionLoading": "Header-module__gGWhea__searchSuggestionLoading",
  "searchSuggestionName": "Header-module__gGWhea__searchSuggestionName",
  "searchSuggestions": "Header-module__gGWhea__searchSuggestions",
  "searchSuggestionsScroll": "Header-module__gGWhea__searchSuggestionsScroll",
  "searchTagline": "Header-module__gGWhea__searchTagline",
  "searchTaglineSep": "Header-module__gGWhea__searchTaglineSep",
  "searchViewAll": "Header-module__gGWhea__searchViewAll",
});
